/* eslint-env browser, jquery */
/* global Modernizr */

import domify from 'domify';
import page from 'modules/ab-page-js';
import metrics from 'modules/metrics';
import container from 'modules/section-content';
import load from 'scriptloader';
import Batch from 'batch';
import metadata from './data/metadata.json';
import splash from './views/main.pug';

export default function register() {
  page('/wordpress', render, loadScripts, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  return next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    load('https://cdn.auth0.com/website/assets/pages/wordpress/vendor/jquery-3ab5f5c956.event.move.js', () => {
      load('https://cdn.auth0.com/website/assets/pages/wordpress/vendor/jquery-69dad42b8b.twentytwenty.js', () => {
        load('https://cdn.auth0.com/website/assets/pages/wordpress/vendor/jquery-e175ed3d7c.superscrollorama.js', () => {
          load('https://cdn.auth0.com/website/assets/pages/wordpress/vendor/tweenlite-5a0a1d77b2.min.js', done);
        });
      });
    });
  });

  batch.push(done => {
    load('//ajax.aspnetcdn.com/ajax/modernizr/modernizr-2.8.3.js', done);
  });

  return batch.end(next);
}

function snippets(ctx, next) {
  $('#beforeafter').twentytwenty();

  $('a.btn.btn-success.btn-lg').on('click', () => {
    metrics.lib().track('click:download-wordpress-plugin');
  });

  if (!Modernizr.touch) {
    $.superscrollorama({
      triggerAtCenter: false,
      playoutAnimations: true
    });
  }

  next();
}



// WEBPACK FOOTER //
// ./src/pages/wordpress/client.js